var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStaff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.16602C3.61008 7.13087 6.36969 7.03504 8.33366 9.16602M7.07957 3.74935C7.07957 4.89994 6.1455 5.83268 4.99327 5.83268C3.84104 5.83268 2.90697 4.89994 2.90697 3.74935C2.90697 2.59876 3.84104 1.66602 4.99327 1.66602C6.1455 1.66602 7.07957 2.59876 7.07957 3.74935Z",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 18.334C13.6101 16.2988 16.3697 16.203 18.3337 18.334M17.0796 12.9173C17.0796 14.0679 16.1455 15.0007 14.9933 15.0007C13.841 15.0007 12.907 14.0679 12.907 12.9173C12.907 11.7667 13.841 10.834 14.9933 10.834C16.1455 10.834 17.0796 11.7667 17.0796 12.9173Z",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.6667C2.5 14.8917 5.10833 17.5 8.33333 17.5L7.5 15.8333",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5H17.5M12.5 5H17.5M12.5 7.5H15.4167",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaff);
export default __webpack_public_path__ + "static/media/icon-staff.48dc7b86d70d136746161158a80a5014.svg";
export { ForwardRef as ReactComponent };